import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance, { isAxiosError } from "@/utils/axiosInstance";
import { Params } from "@/types";

const endpoint = {
  adminFinanceDashboard: "/admin/asaas/finance/dashboard",
};

export const fetchAdminFinanceDashboard = createAsyncThunk(
  "adminFinanceDashboard/fetchAdminFinanceDashboard",
  async (params: Params, thunkAPI) => {
    try {
      const response = await axiosInstance.get(endpoint.adminFinanceDashboard, {
        params,
      });

      // normalize: most APIs return { data }
      const raw = response.data?.data ?? response.data ?? {};

      // build sensible defaults for admin finance dashboard (Asaas)
      const pAny = params as any;
      const defaults = {
        filters: {
          start_date: pAny?.start_date ?? pAny?.date_from ?? null,
          end_date: pAny?.end_date ?? pAny?.date_to ?? null,
        },
        cards: {
          saldo_asaas: 0,
          faturas_pagas_total: 0,
          faturas_pagas_count: 0,
          mensalidades_total: 0,
          splits_total: 0,
          splits_total_future: 0,
          asaas_inflow_total: 0,
          asaas_outflow_total: 0,
          asaas_net_flow: 0,
        },
        charts: {
          payments_series: [],
          faturas_pagas_series: [],
          mensalidades_series: [
            {
              period: "2025-10",
              value: 500,
            },
            {
              period: "2025-11",
              value: 750,
            },
            {
              period: "2026-01",
              value: 839.3,
            },
          ],
          splits_series: [],
          asaas_series: [],
          method_breakdown: [],
          splits_breakdown: [],
          asaas_by_type: [],
        },
        lists: {
          asaas_transactions: {
            items: [],
            pagination: { page: 1, per_page: 50, total: 0, total_pages: 0 },
          },
          payments: {
            items: [],
            pagination: { page: 1, per_page: 50, total: 0, total_pages: 0 },
          },
          establishment_payments: {
            items: [],
            pagination: { page: 1, per_page: 50, total: 0, total_pages: 0 },
          },
        },
      } as any;

      // Merge raw onto defaults but ensure `filters` does not include group_by
      const merged = {
        ...defaults,
        ...raw,
        filters: {
          ...defaults.filters,
          ...(raw.filters || {}),
        },
      };

      // Remove group_by if present
      if (merged.filters && "group_by" in merged.filters) {
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete merged.filters.group_by;
      }

      return merged;
    } catch (error) {
      if (isAxiosError(error)) {
        const errorMessage = error?.response?.data as {
          message?: string;
        };
        return thunkAPI.rejectWithValue({
          error: errorMessage?.message || error.message,
        });
      }
      return thunkAPI.rejectWithValue({
        error: "Erro ao carregar dashboard financeiro (admin).",
      });
    }
  },
);
